export default "__VITE_ASSET__b7e87dc8__"